import { render } from "./trending-block.vue?vue&type=template&id=6db0ae9a"
import script from "./trending-block.vue?vue&type=script&lang=js"
export * from "./trending-block.vue?vue&type=script&lang=js"

import "./trending-block.vue?vue&type=style&index=0&id=6db0ae9a&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__